export const ASSET_EQUIPMENTS_LOADED = "Charisma.Leasing.PublishedLanguage.Events.Asset.AssetEquipmentsLoaded";
